module.exports = __webpack_public_path__ + "static/media/one-on-one-creator.649c48c4.svg";